/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is a single 'ideal weight' better than a range?`)
};

const es_hw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es mejor un único 'peso ideal' que un rango?`)
};

const de_hw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist ein einziges 'Idealgewicht' besser als ein Bereich?`)
};

const nl_hw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is een enkel 'ideaal gewicht' beter dan een bereik?`)
};

const fr_hw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un seul « poids idéal » est-il mieux qu'une plage ?`)
};

const it_hw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È meglio un singolo 'peso ideale' o un intervallo?`)
};

const pt_br2_hw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um único 'peso ideal' é melhor que uma faixa?`)
};

const pt_hw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É um único 'peso ideal' melhor do que um intervalo?`)
};

const ja_hw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単一の「理想体重」は範囲よりも優れていますか？`)
};

const zh_hw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单一的“理想体重”数值是否比一个范围更好？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hw_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hw_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hw_faq2_q", locale)
	if (locale === "en") return en_hw_faq2_q(inputs)
	if (locale === "es") return es_hw_faq2_q(inputs)
	if (locale === "de") return de_hw_faq2_q(inputs)
	if (locale === "nl") return nl_hw_faq2_q(inputs)
	if (locale === "fr") return fr_hw_faq2_q(inputs)
	if (locale === "it") return it_hw_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_hw_faq2_q(inputs)
	if (locale === "pt") return pt_hw_faq2_q(inputs)
	if (locale === "ja") return ja_hw_faq2_q(inputs)
	return zh_hw_faq2_q(inputs)
};